<template>
  <form id="login-form" class="form" @submit.prevent="handleSubmit">
    <div class="log_main">
      <div class="bindPhine_title">
        <p>请设置新密码</p>
      </div>
      <PassEditor ref="passEditor" />
      <div class="logBtnOuter">
        <BtnWithLoading
          type="submit"
          class="btn"
          :disabled="!passEditor.isValid"
          :loading="isPending"
          >下一步</BtnWithLoading
        >
      </div>
    </div>
  </form>
</template>
<script>
import { mapState, updateStore, handleErr } from '@/mixins';

export default {
  mixins: [mapState, updateStore, handleErr],
  data() {
    return {
      pageName: '',
      passEditor: {},
    };
  },
  mounted() {
    if (!this.account) {
      this.$router.replace('/login');
    }
    this.pageName = this.$route.query.pageName || '修改密码';
    this.passEditor = this.$refs.passEditor;
  },
  methods: {
    handleSubmit() {
      const payload = {
        _csrf: this.csrf,
        challenge: this.challenge,
        LoginType: this.loginType,
      };

      payload.account_name = this.account && this.encrypter.encrypt(this.account);
      payload.new_pwd = this.passEditor.newPass
        && this.encrypter.encrypt(this.passEditor.newPass);
      payload.repeat_new_pwd = this.passEditor.repeatNewPass
        && this.encrypter.encrypt(this.passEditor.repeatNewPass);

      // code
      payload.code = this.resetPwdCode || this.$route.query.code;

      this.isPending = true;
      this.$api
        .resetpwd(payload)
        .then((res) => {
          this.isPending = false;
          const data = res.data || {};
          if (data.errcode !== '0' && data.errmsg) {
            this.updateStore('errmsg', data.errmsg);
          }
        })
        .catch((err) => {
          this.handleErr(err);
        });
    },
  },
};
</script>
